import React, { Fragment } from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import { X } from 'react-feather'

import { ModalPaymentDate } from './Module/ModulePaymentDate';
import { ModalInsuranceRenewal } from './Module/ModuleInsuranceRenewal';
import { ModuleGPSRenewal } from './Module/ModuleGPSRenewal';



export const ModalModule = ({ useFetchInit}) => {
    const { dataModal, toggle } = useFetchInit
    const { open, titleModal, componentModal, dataRequest } = dataModal
    const { message1, message2, message3 } = dataRequest || {}

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={toggle}
                fullWidth
                maxWidth='md'
                aria-labelledby='customized-dialog-title'
                tabIndex={-1}
            >
                <DialogTitle id='customized-dialog-title' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {titleModal}
                    <IconButton aria-label='close' onClick={toggle}>
                        <X />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    
                    {componentModal === 'event-section' && (
                        <ModalPaymentDate useFetchInit={useFetchInit}  dataRequest={dataRequest}/>
                    )}
                    {componentModal === 'insurance-section' && (
                        <ModalInsuranceRenewal useFetchInit={useFetchInit}  dataRequest={dataRequest}/>
                    )}
                    {componentModal === 'gps-section' && (
                        <ModuleGPSRenewal useFetchInit={useFetchInit}  dataRequest={dataRequest}/>
                    )}
                    
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}